import { LoadingStatuses } from 'core/common/entities';
import { Flow } from 'core/flow/entities';
import { FunnelConfig } from '../entities';

export type FunnelConfigState = {
  config: FunnelConfig | null;
  loadingStatus: LoadingStatuses;
  funnelName: string;
  flow: Flow | null;
};

export const funnelConfigInitialState: FunnelConfigState = {
  config: null,
  loadingStatus: LoadingStatuses.IDLE,
  funnelName: '',
  flow: null,
};
